import { useContext } from 'react';
import { FormDataContext } from '../../globalState/FormDataContext';

const useFormData = () => {
  const [formDataState] = useContext(FormDataContext);

  const { firstName, lastName, Phone } = formDataState.formData;
  return {
    firstName,
    lastName,
    Phone,
  };
};

export default useFormData;
